let currentUrl = new URL(window.location.href);
let params = new URLSearchParams(currentUrl.search);

if (params.get("or") === "true") {
  setCookie("currency_overide", "true", 7); // set for 7 days (you can change this)
  console.log("currency_overide cookie set to true");
}

var currency_overide = getCookie("currency_overide");
console.log("currency_overide:" + currency_overide);

if (currency_overide == null) {
  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const userCountry = data.country;
      const currentDomain = window.location.hostname;

      if (
        userCountry === "US" &&
        currentDomain.includes("thecoverbrothers.ca")
      ) {
        window.location.href = window.location.href.replace(
          "thecoverbrothers.ca",
          "thecoverbrothers.net"
        );
      } else if (
        userCountry === "CA" &&
        currentDomain.includes("thecoverbrothers.net")
      ) {
        window.location.href = window.location.href.replace(
          "thecoverbrothers.net",
          "thecoverbrothers.ca"
        );
      }
      // 🌍 Handle international visitors (outside US/CA)
      else if (!["US", "CA"].includes(userCountry)) {
        // You can choose which site is better for international users
        if (!currentDomain.includes("thecoverbrothers.ca")) {
          window.location.href = window.location.href.replace(
            currentDomain,
            "thecoverbrothers.ca"
          );
        }
        // Or if you prefer .net for international
        // if (!currentDomain.includes("thecoverbrothers.net")) {
        //   window.location.href = window.location.href.replace(currentDomain, "thecoverbrothers.net");
        // }
      }
    })
    .catch((error) => {
      console.warn("Geolocation lookup failed:", error);
    });
}

function getCookie(name) {
  let match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

$(document).ready(function () {
  // Default to CAD if no cookie is set
  let cartCurrency = getCookie("cart_currency") || "CAD";

  // Set the correct flag and text based on the cookie
  let selectedItem = $(".cs_dropdown-item[data-value='" + cartCurrency + "']");
  let selectedFlag = selectedItem.data("flag");
  let selectedText = selectedItem.data("text");

  console.log("load country:" + selectedText);
  $(".cs_flag-img").attr("src", selectedFlag);
  $(".cs_selected-text").empty();
  $(".cs_selected-text").text(selectedText);

  // Highlight the selected option in the dropdown
  $(".cs_dropdown-item").removeClass("active");
  selectedItem.addClass("active");

  // Handle currency selection
  $(document).on("click", ".cs_dropdown-item", function () {
    console.log("working down-item");
    let newCurrency = $(this).data("value");
    let newFlag = $(this).data("flag");
    let newText = $(this).data("text");

    $(".cs_flag-img").attr("src", newFlag);
    $(".cs_selected-text").empty();
    $(".cs_selected-text").text(newText);

    // Highlight the selected item
    $(".cs_dropdown-item").removeClass("active");
    $(this).addClass("active");

    // Update the cookie
    setCookie("cart_currency", newCurrency, 7);
    setCookie("currency_overide", true, 7);

    // Redirect based on selected currency
    let baseUrl = "";
    if (newCurrency === "CAD") {
      baseUrl = "https://thecoverbrothers.ca/";
    } else if (newCurrency === "USD") {
      baseUrl = "https://thecoverbrothers.net/";
    } else {
      // fallback: stay on current domain
      baseUrl = window.location.origin + "/";
    }

    let currentUrl = new URL(baseUrl);
    let params = new URLSearchParams();
    params.set("currency", newCurrency);
    params.set("or", true);

    const targetUrl = `${baseUrl}/?or=true`;

    currentUrl.search = params.toString();
    console.log("url:" + currentUrl.toString());

    window.location.replace(targetUrl);
  });
});
